module.exports = __webpack_public_path__ + "static/icons/icon-snow-alert-ab54590973524874a551b5eb34ed8bc8.svg";